import React from "react";
import PremiumResourcePage, { resourceMoney } from "../../../Components/Dashboard/PremiumResourcePage";
import ExpensesUpdate from "./ExpensesUpdate";

function Expenses({ navigation }) {
  return (
    <PremiumResourcePage
      navigation={navigation}
      title="Expenses"
      subtitle="Track business expenses, paid-through accounts, and receipts."
      createRoute="ExpensesNew"
      createLabel="+ New Expense"
      fetchEndpoint="/fetchExpenses"
      documentType="expense"
      deleteEndpoint="/deleteExpense/:id"
      deleteKey="id"
      totalKey="amount"
      renderEdit={(row, handleCancel) => (
        <ExpensesUpdate expenseId={row.id} handleCancel={handleCancel} />
      )}
      columns={[
        { key: "date", label: "Date" },
        { key: "expenseAccount", label: "Expense Account" },
        {
          key: "invoice",
          label: "Invoice",
          render: (row) => (
            <button className="premium-link" type="button">
              {row.invoice || row.id || "-"}
            </button>
          ),
        },
        { key: "paidThrough", label: "Paid Through" },
        { key: "amount", label: "Amount", className: "premium-money", render: (row) => resourceMoney(row.amount) },
      ]}
    />
  );
}

export default Expenses;
